import _, { property } from "lodash";
import moment from "moment";
import { create } from "zustand";
import { default as common } from "./common";
import { ui_helpers, date_helpers, input_validation } from "../../../helpers";
import { constants } from "../../../utils";
const { PHASE_NAMES } = common;

function getCustomerWarnings(state) {
  let warnings = [];
  const { firstName, lastName, isRTO, licenseNo, ssn, isQuote, companyId, ownershipCompanyList, customerPhone1,
    secondaryPhone, dateOfBirth, region, deliveryName, deliveryAddress1, deliveryCity, deliveryState, deliveryZip,
    billingName, billingAddress1, billingCity, billingState, billingZip, dealer } = state;

  if (!dealer || !dealer.value) {
    warnings.push({ text: "Select a store.", field: "dealer" });
  }
  if (!firstName || _.trim(firstName).length < 2) {
    warnings.push({ text: "Provide a first name.", field: "firstName" });
  }
  if (!lastName || _.trim(lastName).length < 2) {
    warnings.push({ text: "Provide a last name.", field: "lastName" });
  }
  if (isRTO && (!licenseNo || _.trim(licenseNo).length < 5) && (!ssn || _.trim(ssn).length < 9)) {
    warnings.push({
      text: "Provide either a SSN or a License #.",
      field: "ssn",
    });
  }
  if (isRTO && ssn && ssn.replace(/[-]/g, "").length !== 9) {
    warnings.push({
      text: "Either leave Customer SSN empty or enter a valid value.",
      field: "ssn",
    });
  }
  if (!isRTO && !isQuote && !companyId && ownershipCompanyList && ownershipCompanyList.length > 0) {
    warnings.push({
      text: "Select a company that will own this cash sale.",
      field: "companyId"
    });
  }
  if (!isQuote && (!customerPhone1 || _.trim(customerPhone1).length < 10) && (!secondaryPhone || _.trim(secondaryPhone).length < 10)) {
    warnings.push({
      text: "Provide either a Cell phone or a Secondary phone.",
      field: "customerPhone1",
    });
  }
  if (isRTO && !dateOfBirth) {
    warnings.push({
      text: "Provide a valid date of birth.",
      field: "dateOfBirth",
    });
  }
  if (isRTO && dateOfBirth && date_helpers.calculateAge(dateOfBirth) < 18) {
    warnings.push({
      text: "Customers must be 18 years old or older.",
      field: "dateOfBirth",
    });
  }
  if (!region || (region && !region.value)) {
    warnings.push({ text: "Select a region.", field: "region" });
  }
  if (!isQuote) {
    if (!deliveryName || _.trim(deliveryName).length < 2) {
      warnings.push({
        text: "Provide a delivery name.",
        field: "deliveryName",
      });
    }
    if (!deliveryAddress1 || _.trim(deliveryAddress1).length < 2) {
      warnings.push({
        text: "Provide a delivery address.",
        field: "deliveryAddress1",
      });
    }
    if (!deliveryCity || _.trim(deliveryCity).length < 2) {
      warnings.push({
        text: "Provide a delivery city.",
        field: "deliveryCity",
      });
    }
    if (!deliveryState || _.trim(deliveryState).length < 2) {
      warnings.push({
        text: "Provide a delivery state.",
        field: "deliveryState",
      });
    }
    if (!deliveryZip || _.trim(deliveryZip).length < 2) {
      warnings.push({
        text: "Provide a delivery zip.",
        field: "deliveryZip",
      });
    }
    if (!billingName || _.trim(billingName).length < 2) {
      warnings.push({
        text: "Provide a billing name.",
        field: "billingName",
      });
    }
    if (!billingAddress1 || _.trim(billingAddress1).length < 2) {
      warnings.push({
        text: "Provide a billing address.",
        field: "billingAddress1",
      });
    }
    if (!billingCity || _.trim(billingCity).length < 2) {
      warnings.push({
        text: "Provide a billing city.",
        field: "billingCity",
      });
    }
    if (!billingState || _.trim(billingState).length < 2) {
      warnings.push({
        text: "Provide a billing state.",
        field: "billingState",
      });
    }
    if (!billingZip || _.trim(billingZip).length < 2) {
      warnings.push({
        text: "Provide a billing zip.",
        field: "billingZip",
      });
    }
  }
  if (!region) {
    warnings.push({
      text: "Region is required",
      field: "region"
    });
  }
  if (region && deliveryState && parseInt(region.value, 10) !== constants.OTHER_ID && region.abbr.toUpperCase() !== deliveryState.toUpperCase()) {
    warnings.push({
      text: "Region and delivery state must match.",
      field: "region"
    });
  }
  return warnings;
}

function getCustomerRelationWarnings(state) {
  let warnings = [];
  const {isRTO, corenterEmail, employmentType, employerName, propertyOwner, landOwnerFirstName, landOwnerLastName, 
    landOwnerAddress1, landOwnerCity, landOwnerState, landOwnerZip, landOwnerPhone, corenterFirstName, 
    corenterLastName, corenterAddress1, corenterAddress2, corenterCity, corenterState, corenterZip, corenterPhone, 
    corenterDateOfBirth, contact1FirstName, contact1LastName, contact1Phone, contact1Relationship, contact1Email, additionalContactData} = state;
  if (!isRTO)
    return warnings;
  if (corenterEmail && !input_validation.is_email(corenterEmail)) {
    warnings.push({
      text: "Provide a valid corenter email address or leave it empty.",
      field: "corenterEmail",
    });
  }
  if (!employmentType) {
    warnings.push({
      text: "Provide a valid employment type.",
      field: "employmentType",
    });
  }
  if (employmentType && constants.EMPLOYMENT_TYPES_REQUIRING_EMPLOYER.includes(employmentType.label)) {
    if (!employerName || _.trim(employerName).length < 2) {
      warnings.push({
        text: "Missing employer name.",
        field: "employerName",
      });
    }
  }
  if (!propertyOwner) {
    if (!landOwnerFirstName || _.trim(landOwnerFirstName).length < 2) {
      warnings.push({
        text: "Landowner First Name is required (since the customer is not the landowner).",
        field: "landOwnerFirstName",
      });
    }
    if (!landOwnerLastName || _.trim(landOwnerLastName).length < 2) {
      warnings.push({
        text: "Landowner Last Name is required (since the customer is not the landowner).",
        field: "landOwnerLastName",
      });
    }
    if (!landOwnerAddress1 || _.trim(landOwnerAddress1).length < 2) {
      warnings.push({
        text: "Landowner Address is required (since the customer is not the landowner).",
        field: "landOwnerAddress1",
      });
    }
    if (!landOwnerCity || _.trim(landOwnerCity).length < 2) {
      warnings.push({
        text: "Landowner City is required (since the customer is not the landowner).",
        field: "landOwnerCity",
      });
    }
    if (!landOwnerState || _.trim(landOwnerState).length < 2
    ) {
      warnings.push({
        text: "Landowner State is required (since the customer is not the landowner).",
        field: "landOwnerState",
      });
    }
    if (!landOwnerZip || _.trim(landOwnerZip).length < 2) {
      warnings.push({
        text: "Landowner Zip is required (since the customer is not the landowner).",
        field: "landOwnerZip",
      });
    }
    if (!landOwnerPhone || _.trim(landOwnerPhone).length < 2) {
      warnings.push({
        text: "Landowner Phone is required (since the customer is not the landowner).",
        field: "landOwnerPhone",
      });
    }
  }
  const corenterFieldsProvided =
    corenterFirstName ||
    corenterLastName ||
    corenterAddress1 ||
    corenterAddress2 ||
    corenterCity ||
    corenterState ||
    corenterZip ||
    corenterPhone ||
    corenterEmail;
  if (
    corenterFieldsProvided &&
    (!corenterFirstName ||
      !corenterLastName ||
      !corenterAddress1 ||
      !corenterCity ||
      !corenterState ||
      !corenterZip ||
      !corenterPhone ||
      !corenterDateOfBirth)
  ) {
    warnings.push({
      text: "Corenter information is optional, but all fields are required if any are entered. Either clear or enter all corenter data.",
      field: "corenterFirstName",
    });
  }
  if (!additionalContactData
    || !additionalContactData.contact1FirstName
    || _.trim(additionalContactData.contact1FirstName).length < 2) {
    warnings.push({
      text: "At least 1 valid, additional contact is required.",
      field: "contact1FirstName",
    });
  }
  if (!additionalContactData
    || !additionalContactData.contact1LastName
    || _.trim(additionalContactData.contact1LastName).length < 2
  ) {
    warnings.push({
      text: "At least 1 valid, additional contact is required.",
      field: "contact1LastName",
    });
  }
  if (!additionalContactData
    || !additionalContactData.contact1Phone
    || _.trim(additionalContactData.contact1Phone).length < 2
  ) {
    warnings.push({
      text: "At least 1 valid, additional contact is required.",
      field: "contact1Phone",
    });
  }
  if (!additionalContactData
    || !additionalContactData.contact1Relationship
    || _.trim(additionalContactData.contact1Relationship).length < 2
  ) {
    warnings.push({
      text: "At least 1 valid, additional contact is required.",
      field: "contact1Relationship",
    });
  }
  if (additionalContactData
    && additionalContactData.contact1Email
    && !input_validation.is_email(additionalContactData.contact1Email)
  ) {
    warnings.push({
      text: "Either enter a valid additional contact email address (1) or leave it empty.",
      field: "contact1Email",
    });
  }
  return warnings;
}

function getUnitWarnings(state) {
  let warnings = [];
  const {enableCustomSerialGeneration, serialNumber, manufacturerId, otherManufacturer, hasSku, widthFeetOtherText, lengthFeetOtherText,
    isQuote, buildingOrientation, unitType, hideUnitType, unitTypeOtherText, productType, baseColor, otherBaseColor, trimColor, otherTrimColor, 
    roofColor, otherRoofColor, subproduct, otherSubproduct, unitIsNew, unitIsInventory, dealer} = state;
  if (!dealer || !dealer.value) {
    warnings.push({ text: "Select a store.", field: "dealer" });
  }
  if (!enableCustomSerialGeneration && (!serialNumber || _.trim(serialNumber).length < 2)) {
    warnings.push({
      text: "Either enter a serial # (TBD or MADE TO ORDER is acceptable if appropriate).",
      field: "serialNumber",
    });
  }
  if (manufacturerId === constants.OTHER_ID && (!otherManufacturer || _.trim(otherManufacturer).length < 2)) {
    warnings.push({
      text: "Either select a valid manufacturer or enter a description.",
      field: "manufacturer",
    });
  }
  if (!hasSku) 
  {
    if (!widthFeetOtherText) {
      warnings.push({
        text: "Either select a valid size or enter a width description.",
        field: "widthFeet",
      });
    }
    if (!lengthFeetOtherText) {
      warnings.push({
        text: "Either select a valid size or enter a length description.",
        field: "lengthFeet",
      });
    }
  }
  if(!isQuote && !buildingOrientation) {
    warnings.push({
      text: 'You must choose a building orientation.',
      field: 'buildingOrientation',
    });
  }
  if (!unitType && !hideUnitType) {
    warnings.push({ text: "Material is missing.", field: "unitType" });
  }
  if (unitType
    && unitType.value === constants.OTHER_ID 
    && (!unitTypeOtherText || _.trim(unitTypeOtherText).length < 2)
    && !hideUnitType
  ) {
    warnings.push({
      text: "Either select a valid material or enter a description.",
      field: "unitType",
    });
  }
  if (productType && !baseColor && otherBaseColor === "" && productType.value !== constants.PRODUCT_TYPE_IDS.CARPORT) {
    warnings.push({ text: "Base color is missing.", field: "baseColor" });
  }
  if (productType && baseColor && baseColor.value === constants.OTHER_ID && productType.value !== constants.PRODUCT_TYPE_IDS.CARPORT
      && (!otherBaseColor || _.trim(otherBaseColor).length < 2)) {
    warnings.push({
      text: "Either select a valid base color or enter a description.",
      field: "baseColor",
    });
  }
  if (!trimColor && otherTrimColor === "") {
    warnings.push({ text: "Trim color is missing.", field: "trimColor" });
  }
  if (
    trimColor &&
    trimColor.value === constants.OTHER_ID &&
    (!otherTrimColor ||
      _.trim(otherTrimColor).length < 2)
  ) {
    warnings.push({
      text: "Either select a valid trim color or enter a description.",
      field: "trimColor",
    });
  }
  if (!roofColor && otherRoofColor === "") {
    warnings.push({ text: "Roof color is missing.", field: "roofColor" });
  }
  if (
    roofColor &&
    roofColor.value === constants.OTHER_ID &&
    (!otherRoofColor ||
      _.trim(otherRoofColor).length < 2)
  ) {
    warnings.push({
      text: "Either select a valid roof color or enter a description.",
      field: "roofColor",
    });
  }
  if (!subproduct && otherSubproduct === "") {
    warnings.push({ text: "Style is missing.", field: "subproduct" });
  }
  if (
    subproduct &&
    subproduct.value === constants.OTHER_ID &&
    (!otherSubproduct ||
      _.trim(otherSubproduct).length < 2)
  ) {
    warnings.push({
      text: "Either select a valid style or enter a description.",
      field: "subproduct",
    });
  }
  if(!isQuote && !buildingOrientation) {
    warnings.push({
      text: 'Select a Delivery Building Orientation.',
      field: 'deliveryBuildingOrientation'
    })
  }
  if(unitIsNew === null || unitIsInventory === null){
      warnings.push({
          text: 'Both Unit Condition and Inventory type are required.',
          field: 'unitIsNew'
      });
  }
  return warnings;
}

function getPricingWarnings(state) {
  let warnings = [];
  const {isRTO, deliveryCounty, taxRate, selectedTermInfo, unitPrice, salesperson, otherSalesperson, estimatedDeliveryDate, 
    initialPaymentAmount, maxInitialPaymentAmount, isTaxExempt, taxExemptionForm} = state;
    if (!isRTO)
      return warnings;
  if (!deliveryCounty){
      warnings.push({
          text: "Delivery county is required.",
          field: "deliveryCounty",
      });
  }
  if (deliveryCounty === "" && (taxRate === "" || !taxRate) && parseInt(taxRate, 10) !== 0) {
      warnings.push({
          text: "Please enter a valid Delivery county and/or Tax Rate. You can use the 'Find Tax Rate' feature to look up the appropriate county and rate. Be sure to check whether or not the county is within city limits.",
          field: "deliveryCounty",
      });
  }
  if (!selectedTermInfo) {
    warnings.push({
      text: "You must select a contract term.",
      field: "initialPaymentAmount",
    });
  }
  if (!unitPrice || parseFloat(unitPrice) < 10.0) {
    warnings.push({
      text: "Unit price must be a valid value.",
      field: "unitPrice",
    });
  }
  if (!salesperson) {
    warnings.push({
      text: "You must select a salesperson.",
      field: "salesperson",
    });
  }
  if (salesperson && salesperson.value === constants.OTHER_ID && (!otherSalesperson || _.trim(otherSalesperson).length < 2)) {
    warnings.push({
      text: "Either select a valid salesperson or enter a description.",
      field: "otherSalesperson",
    });
  }
  if (estimatedDeliveryDate && date_helpers.isBefore(estimatedDeliveryDate, moment())) {
    warnings.push({
      text: `The estimated delivery date must either be left blank or be set to a date in the future. ${date_helpers.formatDateToShortDate(
        estimatedDeliveryDate
      )} is in the past.`,
      field: "estimatedDeliveryDate",
    });
  }
  if (selectedTermInfo && initialPaymentAmount < selectedTermInfo.requiredForDeliveryAmount_NOPR) {
      warnings.push({
        text: `The initial payment amount (${initialPaymentAmount}) is below the minimum required for delivery amount `,
        field: "initialPaymentAmount",
      });
  }
  if ((initialPaymentAmount > maxInitialPaymentAmount) && (maxInitialPaymentAmount > 0)) {
    warnings.push({text: `You've exceeded the maximum amount paid today amount of ${maxInitialPaymentAmount} for the unit price (${unitPrice}).`, field: 'initialPaymentAmount'});
  }
  if(initialPaymentAmount === "0.00"){
      warnings.push({text: "You must enter an a Down Payment.", field: "initialPaymentAmount"});
  }
  if(isTaxExempt && !taxExemptionForm) {
      warnings.push({text: "If this item is marked as tax exempt you must provide an exemption form.", field: "taxRate"});
  }
  if(taxRate === 0 && !isTaxExempt) {
    warnings.push({text: "Tax rate was entered as 0. Either mark this item as Tax Exempt or enter a valid tax rate.", field: "taxRate"});
  }
  return warnings;
}

function getQuotePricingWarnings(state) {
  let warnings = [];
  const {convertTo, selectedTermInfo, unitPrice, mfgExpirationDate} = state;
  if (convertTo !== constants.RTO_STRING)
    return warnings;
  if (!selectedTermInfo) {
    warnings.push({
      text: "You must select a contract term.",
      field: "selectedContractTerm",
    });
  }
  if (!unitPrice || parseFloat(unitPrice) < 10.0) {
    warnings.push({
      text: "Unit price must be a valid value.",
      field: "unitPrice",
    });
  }
  if (mfgExpirationDate && date_helpers.isBefore(mfgExpirationDate, moment())) {
    warnings.push({
      text: `The expiry date must be set to a date in the future. ${date_helpers.formatDateToShortDate(mfgExpirationDate)} is in the past.`,
        field: "mfgExpirationDate",
    });
  }
  return warnings;
}

function getPaymentWarnings(state) {
  let warnings = [];
  const {paymentList, isRTO, initialPaymentAmount, deliveryCounty, taxRate, isTaxExempt, taxExemptionForm} = state;
  const sumOfPayments = _.sumBy(paymentList, x => x.amount);
  if (isRTO) {
    if (!parseFloat(initialPaymentAmount) > 0.00) {
      warnings.push({text: 'You must provide an Initial Payment amount', field: 'initialPaymentAmount'});
    }
    if (initialPaymentAmount > 0 
      && paymentList.length
      && Math.round(parseFloat(initialPaymentAmount)) > Math.round(parseFloat(sumOfPayments))) {
      warnings.push({text: `The initial payment amount (${initialPaymentAmount}) is greater from the sum of entered payments (${sumOfPayments}). Either adjust the payment sum or correct the Initial Payment Amount.`, field: 'initialPaymentAmount'});
    }
  } else {
    if (deliveryCounty === "" || !deliveryCounty) {
        warnings.push({
            text: "Delivery county is required.",
            field: "deliveryCounty",
        });
    }
  }
  if (deliveryCounty === "" && (taxRate === "" || !taxRate) && parseInt(taxRate, 10) !== 0) {
    warnings.push({
        text: "Please enter a valid Delivery county and/or Tax Rate. You can use the 'Find Tax Rate' feature to look up the appropriate county and rate. Be sure to check whether or not the county is within city limits.",
        field: "deliveryCounty",
    });
  }
  if(isTaxExempt && !taxExemptionForm) {
    warnings.push({text: "If this item is marked as tax exempt you must provide an exemption form.", field: "taxRate"});
  }
  if(taxRate === 0 && !isTaxExempt) {
    warnings.push({text: "Tax rate was entered as 0. Either mark this item as Tax Exempt or enter a valid tax rate.", field: "taxRate"});
  }
  return warnings;
}

function resolveLength(state) {
  return parseFloat(_.trim(state.lengthFeetOtherText)
    ? state.lengthFeetOtherText
    : state.lengthFeet);
}

function resolveWidth(state) {
  return parseFloat(_.trim(state.widthFeetOtherText)
    ? state.widthFeetOtherText
    : state.widthFeet);
}

function getWarnings(state, overridePhaseName = null) {
  const resolvedPhaseName = overridePhaseName ? overridePhaseName : state.phaseName;
  switch (resolvedPhaseName) {
    case PHASE_NAMES.CUSTOMER:
      return ({...state, warnings: getCustomerWarnings(state)});
    case PHASE_NAMES.RELATIONS:
      return ({...state, warnings: getCustomerRelationWarnings(state)});
    case PHASE_NAMES.UNITS:
      return ({...state, warnings: getUnitWarnings(state)});
    case PHASE_NAMES.PRICING:
      return ({...state, warnings: getPricingWarnings(state)});
    case PHASE_NAMES.QUOTE_PRICING:
      return ({...state, warnings: getQuotePricingWarnings(state)});
    case PHASE_NAMES.BUILD:
      if (state.enableBuildFeature && !state.inventoryId) {
        return ({...state, warnings: [{ text: "You must complete the Unit Information before continuing with this step.", field: "buildStep" }]});
      }
      return state;
    case PHASE_NAMES.PAYMENT:
      return ({...state, warnings: getPaymentWarnings(state)});
    default:
      return state;
  }
}

const setSkuStateFields = (newState, newSku) => {
  newState.sku = newSku;
  if (newSku && newSku.value !== constants.OTHER_ID) {
    newState.widthFeet = newSku.width;
    newState.lengthFeet = newSku.length;
    newState.typeOfPorch = newSku.porchTypeId;
    newState.porchMax = newSku.porchMax;
    newState.porchMin = newSku.porchMin;
    newState.porchWall1Length = newSku.porchWall1Length;
    newState.porchWall2Length = newSku.porchWall2Length;
    newState.porchWall3Length = newSku.porchWall3Length;
    newState.porchWall4Length = newSku.porchWall4Length;
    // newUnitData.unitManufacturerSubProductSkuId = newSku.value;
    // newUnitData.unitManufacturerSubProductSkuName = newSku.label;
  }
  else
  {
    newState.widthFeet = 0;
    newState.lengthFeet = 0;
    newState.typeOfPorch = null;
    newState.porchMax = 0;
    newState.porchMin = 0;
    newState.porchWall1Length = 0;
    newState.porchWall2Length = 0;
    newState.porchWall3Length = 0;
    newState.porchWall4Length = 0;
  }
  return newState;
};

const updateFinancials = (newState) => {
  newState.taxRateString = ui_helpers.taxRateStringFromTaxRate(newState.taxRate);
  const numericUnitPrice = parseFloat(newState.unitPrice);
  if (!newState.priceAdjustments) {
    newState.priceAdjustments = [];
  }
  const unitPriceAdjustmentsSum = _.sumBy(_.filter(newState.priceAdjustments, pa => pa.includeInUnitPrice), pa => parseFloat(pa.amount)) || 0.0;
  const allAdjustmentsSum = _.sumBy(newState.priceAdjustments, pa => parseFloat(pa.amount));
  newState.taxAmount = parseFloat((parseFloat(newState.taxRate) * (numericUnitPrice + unitPriceAdjustmentsSum)).toFixed(2));
  newState.subtotal = numericUnitPrice + newState.taxAmount + allAdjustmentsSum;
  let rawTotalPayments = 0.0;
  let ccFees = 0.0;
  if (newState.paymentList && newState.paymentList.length) {
    rawTotalPayments = _.sumBy(newState.paymentList, (x) => x.amount);
    ccFees = _.sumBy(newState.paymentList, (x) => {
              return x.typeOfPayment === constants.PAYMENT_TYPE_IDS.CREDIT_CARD_FEE
                ? x.amount
                : 0;
            });
  }
  newState.balanceDue = newState.subtotal - rawTotalPayments + ccFees; // + unitPriceAdjustmentsSum;
  if (newState.balanceDue < 0){
    newState.balanceDue = 0;
  }
  return newState;
};

const updateFirstLastName = (newState, changedFieldName, firstName, lastName) => {
  newState.firstName = firstName;
  newState.lastName = lastName;
  const newValue = changedFieldName === 'firstName'
    ? firstName
    : lastName;
  if (newValue) {
    const proposedValue = `${_.trim(firstName)}${_.trim(lastName) ? " " + _.trim(lastName) : ""}`;
    const minLen = _.min([proposedValue.length, newState.deliveryName ? newState.deliveryName.length : 0]);
    if (minLen === 0 || newState.deliveryName !== proposedValue) { // _.startsWith(newState.deliveryName, proposedValue.substring(0, minLen))
      newState.deliveryName = proposedValue;
    }
  }
  return newState;
};

const getUnitPriceDisabled = (newState, inventoryId, lastPairedInventoryId, enableBuildFeature, agreedPrice, contractType, hasSku) => {
  newState.inventoryId = inventoryId;
  newState.lastPairedInventoryId = lastPairedInventoryId;
  newState.agreedPrice = agreedPrice;
  newState.contractType = contractType;
  newState.isRTO = contractType === constants.CONTRACT_TYPE.RTO;
  newState.isQuote = contractType === constants.CONTRACT_TYPE.QUOTE;
  newState.isCashSale = contractType === constants.CONTRACT_TYPE.CASH_SALE;
  newState.enableBuildFeature = enableBuildFeature;
  newState.hasSku = hasSku;
  newState.unitPriceDisabled = ((newState.inventoryId && !newState.captiveInventoryId) || newState.lastPairedInventoryId || newState.agreedPrice)
    ? true
    : (newState.enableBuildFeature || newState.isQuote) && newState.hasSku;
  // console.log(newState.inventoryId, newState.lastPairedInventoryId, newState.agreedPrice, newState.enableBuildFeature, newState.isQuote, newState.hasSku)
  return newState;
};

const setCustomSerialState = (newState, enableCustomSerialGeneration, unitIsNew, unitIsInventory) => {
  newState.enableCustomSerialGeneration = enableCustomSerialGeneration;
  newState.customSerialEnabled = enableCustomSerialGeneration && unitIsNew === true && unitIsInventory === false;
  newState.unitIsNew = unitIsNew;
  newState.unitIsInventory = unitIsInventory;
  newState.isNewBuild = unitIsNew && !unitIsInventory;
  return newState;
};

const initialState = {
  contractId: null,
  wasInitialCreation: false,
  captiveInventoryId: null,
  requiredPriceOverride: false,
  isQuote: false,
  isRTO: false,
  isCashSale: false,
  contractType: "",
  companyId: null,
  companyName: "",
  paperlessBillingEmail: "",
  creditCardFeePercentage: 0.0,
  enableBuildFeature: false,
  firstName: "",
  lastName: "",
  customerPhone1: "",
  secondaryPhone: "",
  email: "",
  balanceDue: 0,
  ssn: "",
  licenseNo: "",
  dateOfBirth: "",
  culture: "",
  deliveryName: "",
  deliveryAddress1: "",
  deliveryAddress2: "",
  deliveryCity: "",
  deliveryState: "",
  deliveryZip: "",
  deliveryCounty: "",
  billingName: "",
  billingAddress1: "",
  billingAddress2: "",
  billingCity: "",
  billingState: "",
  billingZip: "",
  propertyOwner: "",
  landOwnerFirstName: "",
  landOwnerLastName: "",
  landOwnerAddress1: "",
  landOwnerAddress2: "",
  landOwnerCity: "",
  landOwnerState: "",
  landOwnerZip: "",
  landOwnerPhone: "",
  landOwnerEmail: "",
  employmentType: "",
  employerName: "",
  employerPhone: "",
  employerEmail: "",
  corenterFirstName: "",
  corenterLastName: "",
  corenterAddress1: "",
  corenterAddress2: "",
  corenterCity: "",
  corenterState: "",
  corenterZip: "",
  corenterDateOfBirth: "",
  corenterPhone: "",
  corenterEmail: "",
  enableBuildFeature: false,
  paymentTypes: [],
  attachmentList: [],
  cultures: [],
  regions: [],
  regionId: null,
  region: null,
  widths: [],
  lengths: [],
  heights: [],
  dealers: [],
  dealer: null,
  dealerId: null,
  agreementNumber: "",
  companyEnableCreditCardPayments: false,
  typeOfPorch: null,
  porchMin: 0,
  porchMax: 0,
  porchWall1Length: 0,
  porchWall2Length: 0,
  porchWall3Length: 0,
  porchWall4Length: 0,
  porchColorId: null,
  porchColorName: "",
  fontSize: 0,
  rulerOffSet: 0,
  addOnOptions: [],
  defaultAddOns: [],
  addOns: [],
  existingContractPairingContractId: null,
  existingContractPairingAgreementNumber: null,
  unpairContractId: null,
  screenWarnings: {},
  manufacturers: [],
  employmentTypes: [],
  otherManufacturer: "",
  productTypes: [],
  subProducts: [],
  subproductTypes: [],
  subproduct: null,
  otherSubproduct: "",
  skus: [],
  unitPriceDisabled: false,
  productType: null,
  productTypeOtherText: "",
  sku: null,
  hasSku: false,
  skuBasePrice: 0,
  isPairing: false,
  salespeople: [],
  pendingPriceAdjustment: null,
  salesperson: "",
  otherSalesperson: "",
  unitTypes: [],
  baseColors: [],
  trimColors: [],
  roofColors: [],
  unitPrice: "0",
  taxRate: 0,
  taxRateString: "0.0",
  taxAmount: 0,
  subtotal: 0,
  widthFeet: "0",
  widthFeetOtherText: "",
  lengthFeet: "0",
  lengthFeetOtherText: "",
  heightFeet: "0",
  heightFeetOtherText: "",
  agreedPrice: null,
  inventoryId: null,
  lastPairedInventoryId: null,
  contactCount: 0,
  additionalContactData: {},
  typeOfPorch: null,
  porchMax: null,
  porchMin: null,
  porchWall1Length: null,
  porchWall2Length: null,
  porchWall3Length: null,
  porchWall4Length: null,
  rulerOffset: null,
  serialNumber: "0",
  manufacturer: null,
  manufacturerId: null, // was mfgId
  loadedExistingManufacturerId: null,
  isNewBuild: false,
  estimatedDeliveryDate: null,
  otherRoofColor: "",
  otherTrimColor: "",
  otherBaseColor: "",
  customSerialEnabled: false,
  enableCustomSerialGeneration: false,
  unitIsNew: null,
  unitIsInventory: null,
  roofColor: null,
  trimColor: null,
  baseColor: null,
  unitOtherColorText: null,
  hideUnitType: false,
  ownershipCompanyList: [],
  unitType: null,
  unitTypeOtherText: "", // was otherUnitType
  quoteDownPayment: "",
  priceAdjustments: [],
  pristineUnitIsNew: [],
  paymentList: [],
  cards: [],
  bankAccounts: [],
  associatedBundles: [],
  bundlesToDelete: [],
  bundlePrice: 0,
  creditCardSurcharge: 0,
  damageLiabilityWaiverAmount: "", // was ldwAmount
  optedOutOfDamageLiabilityWaiver: false,
  enableRecurringPayments: false, // was enableRecurring
  mfgExpirationDate: null,
  searchText: "",
  unpairedInvList: null,
  buildingOrientations: [],
  buildingOrientation: null,
  deliveryInstructions: "",
  disableSale: false,
  defaultUnitTypeId: null,
  dueDays: false,
  validationMessage: null,
  phaseName: "",
  includedInitialPayment: false,
  initialPaymentAmount: 0,
  maxInitialPaymentAmount: 0,
  isTaxExempt: false,
  taxExemptionForm: null,
  convertTo: "",
  selectedTermInfo: null,
  promotionCode: "",
  promotionCodeTemp: "",
  paymentDueDayOfMonth: null,
  pricingData: null,
  typeOfContractStatus: null,
  savedAddons: [],
  fieldWarnings: [],
  warnings: [],
  autoShowEditor: false,
  manualCard: null,
  isInitialLoad: true,
  sideFeePayment: 0.0,
  paymentTransferIntentId: null,
  contractTransferPayments: [],
  pendingTransfer: false,
  canSetRetained: false,
  companyAcceptsPayment: null,
  rtoTaxExemptionEnabled: false,
};

const useContractStore = create((set, get) => ({
  contractId: null,
  setContractId: (n) => set((state) => ({ ...state, contractId: n })),
  isInitialLoad: true,
  setIsInitialLoad: (n) => set((state) => ({ ...state, isInitialLoad: n })),
  initialize: (newState) => {
    return set((_oldState) => {
      let toBeState = {
        ...updateFinancials(newState),
        fieldWarnings: [],
        screenWarnings: []
      };
      toBeState.dealerId = toBeState.dealer && toBeState.dealer.value !== constants.OTHER_ID
        ? toBeState.dealer.value
        : null;
      toBeState.manufacturerId = toBeState.manufacturer && toBeState.manufacturer.value
        ? toBeState.manufacturer.value
        : null;
      toBeState.regionId = toBeState.region && toBeState.region.value
        ? toBeState.region.value
        : null;      
      toBeState.isInitialLoad = true;
      toBeState.hasSku = toBeState.sku && toBeState.sku.value && toBeState.sku.value !== constants.OTHER_ID;
      return getUnitPriceDisabled(toBeState, toBeState.inventoryId, toBeState.lastPairedInventoryId, 
        toBeState.enableBuildFeature, toBeState.agreedPrice, toBeState.contractType, toBeState.hasSku);
    });
  },
  wasInitialCreation: false,
  setWasInitialCreation: (n) => set((state) => ({ ...state, wasInitialCreation: n })),
  captiveInventoryId: null,
  setCaptiveInventoryId: (n) => set((state) => ({ ...state, captiveInventoryId: n })),
  requiredPriceOverride: false,
  setRequiredPriceOverride: (n) => set((state) => ({ ...state, requiredPriceOverride: n })),
  isQuote: false,
  setIsQuote: (n) => set((state) => ({ ...state, isQuote: n })),
  isRTO: false,
  setIsRTO: (n) => set((state) => ({ ...state, isRTO: n })),
  isCashSale: false,
  setIsCashSale: (n) => set((state) => ({ ...state, isCashSale: n })),
  contractType: "",
  setContractType: (n) => set((state) => getUnitPriceDisabled({...state}, state.inventoryId, state.lastPairedInventoryId, state.enableBuildFeature,
      state.agreedPrice, n, state.hasSku)),
  companyId: null,
  setCompanyId: (n) => set((state) => ({ ...state, companyId: n })),
  companyName: "",
  setCompanyName: (n) => set((state) => ({ ...state, companyName: n })),
  paperlessBillingEmail: "",
  setPaperlessBillingEmail: (n) => set((state) => ({ ...state, paperlessBillingEmail: n })),
  creditCardFeePercentage: 0.0,
  setCreditCardFeePercentage: (n) => set((state) => ({ ...state, creditCardFeePercentage: n })),
  enableBuildFeature: false,
  firstName: "",
  setFirstName: (n) => set((state) => updateFirstLastName({...state}, 'firstName', ui_helpers.capitalizeFirstLetter(n), state.lastName)),
  lastName: "",
  setLastName: (n) => set((state) => updateFirstLastName({...state}, 'lastName', state.firstName, ui_helpers.capitalizeFirstLetter(n))),
  customerPhone1: "",
  setCustomerPhone1: (n) => set((state) => ({ ...state, customerPhone1: ui_helpers.formatPhoneField(n) })),
  secondaryPhone: "",
  setSecondaryPhone: (n) => set((state) => ({ ...state, secondaryPhone: ui_helpers.formatPhoneField(n) })),
  email: "",
  setEmail: (n) => set((state) => ({ ...state, email: n })),
  balanceDue: 0,
  setBalanceDue: (n) => set((state) => ({ ...state, balanceDue: n })),
  ssn: "",
  setSsn: (n) => set((state) => ({ ...state, ssn: ui_helpers.formatSSNField(n) })),
  licenseNo: "",
  setLicenseNo: (n) => set((state) => ({ ...state, licenseNo: n })),
  dateOfBirth: "",
  setDateOfBirth: (n) => set((state) => ({ ...state, dateOfBirth: ui_helpers.formatDateField(n) })),
  culture: "",
  setCulture: (n) => set((state) => ({ ...state, culture: n })),
  deliveryName: "",
  setDeliveryName: (n) => set((state) => ({ ...state, deliveryName: n })),
  deliveryAddress1: "",
  setDeliveryAddress1: (n) => set((state) => ({ ...state, deliveryAddress1: ui_helpers.capitalizeFirstLetter(n) })),
  deliveryAddress2: "",
  setDeliveryAddress2: (n) => set((state) => ({ ...state, deliveryAddress2: ui_helpers.capitalizeFirstLetter(n) })),
  deliveryCity: "",
  setDeliveryCity: (n) => set((state) => ({ ...state, deliveryCity: ui_helpers.capitalizeFirstLetter(n) })),
  deliveryState: "",
  setDeliveryState: (n) => set((state) => ({ ...state, deliveryState: ui_helpers.capitalizeAllLetters(n) })),
  deliveryZip: "",
  setDeliveryZip: (n) => set((state) => ({ ...state, deliveryZip: n })),
  deliveryCounty: "",
  setDeliveryCounty: (n) => set((state) => ({ ...state, deliveryCounty: ui_helpers.capitalizeFirstLetter(n) })),
  billingName: "",
  setBillingName: (n) => set((state) => ({ ...state, billingName: n })),
  billingAddress1: "",
  setBillingAddress1: (n) => set((state) => ({ ...state, billingAddress1: ui_helpers.capitalizeFirstLetter(n) })),
  billingAddress2: "",
  setBillingAddress2: (n) => set((state) => ({ ...state, billingAddress2: ui_helpers.capitalizeFirstLetter(n) })),
  billingCity: "",
  setBillingCity: (n) => set((state) => ({ ...state, billingCity: ui_helpers.capitalizeFirstLetter(n) })),
  billingState: "",
  setBillingState: (n) => set((state) => ({ ...state, billingState: ui_helpers.capitalizeAllLetters(n) })),
  billingZip: "",
  setBillingZip: (n) => set((state) => ({ ...state, billingZip: n })),
  propertyOwner: "",
  setPropertyOwner: (n) => set((state) => ({ ...state, propertyOwner: n })),
  landOwnerFirstName: "",
  setLandOwnerFirstName: (n) => set((state) => ({ ...state, landOwnerFirstName: ui_helpers.capitalizeFirstLetter(n) })),
  landOwnerLastName: "",
  setLandOwnerLastName: (n) => set((state) => ({ ...state, landOwnerLastName: ui_helpers.capitalizeFirstLetter(n) })),
  landOwnerAddress1: "",
  setLandOwnerAddress1: (n) => set((state) => ({ ...state, landOwnerAddress1: ui_helpers.capitalizeFirstLetter(n) })),
  landOwnerAddress2: "",
  setLandOwnerAddress2: (n) => set((state) => ({ ...state, landOwnerAddress2: ui_helpers.capitalizeFirstLetter(n) })),
  landOwnerCity: "",
  setLandOwnerCity: (n) => set((state) => ({ ...state, landOwnerCity: ui_helpers.capitalizeFirstLetter(n) })),
  landOwnerState: "",
  setLandOwnerState: (n) => set((state) => ({ ...state, landOwnerState: ui_helpers.capitalizeAllLetters(n) })),
  landOwnerZip: "",
  setLandOwnerZip: (n) => set((state) => ({ ...state, landOwnerZip: n })),
  landOwnerPhone: "",
  setLandOwnerPhone: (n) => set((state) => ({ ...state, landOwnerPhone: ui_helpers.formatPhoneField(n) })),
  landOwnerEmail: "",
  setLandOwnerEmail: (n) => set((state) => ({ ...state, landOwnerEmail: n })),
  employmentType: "",
  setEmploymentType: (n) => set((state) => ({ ...state, employmentType: n })),
  employerName: "",
  setEmployerName: (n) => set((state) => ({ ...state, employerName: n })),
  employerPhone: "",
  setEmployerPhone: (n) => set((state) => ({ ...state, employerPhone: ui_helpers.formatPhoneField(n) })),
  employerEmail: "",
  setEmployerEmail: (n) => set((state) => ({ ...state, employerEmail: n })),
  corenterFirstName: "",
  setCorenterFirstName: (n) => set((state) => ({ ...state, corenterFirstName: n })),
  corenterLastName: "",
  setCorenterLastName: (n) => set((state) => ({ ...state, corenterLastName: n })),
  corenterAddress1: "",
  setCorenterAddress1: (n) => set((state) => ({ ...state, corenterAddress1: n })),
  corenterAddress2: "",
  setCorenterAddress2: (n) => set((state) => ({ ...state, corenterAddress2: n })),
  corenterCity: "",
  setCorenterCity: (n) => set((state) => ({ ...state, corenterCity: n })),
  corenterState: "",
  setCorenterState: (n) => set((state) => ({ ...state, corenterState: n })),
  corenterZip: "",
  setCorenterZip: (n) => set((state) => ({ ...state, corenterZip: n })),
  corenterDateOfBirth: "",
  setCorenterDateOfBirth: (n) => set((state) => ({ ...state, corenterDateOfBirth: ui_helpers.formatDateField(n) })),
  corenterPhone: "",
  setCorenterPhone: (n) => set((state) => ({ ...state, corenterPhone: ui_helpers.formatPhoneField(n) })),
  corenterEmail: "",
  setCorenterEmail: (n) => set((state) => ({ ...state, corenterEmail: n })),
  setEnableBuildFeature: (n) => set((state) => getUnitPriceDisabled({...state}, state.inventoryId, state.lastPairedInventoryId, n,
      state.agreedPrice, state.contractType, state.hasSku)),
  paymentTypes: [],
  setPaymentTypes: (n) => set((state) => ({ ...state, paymentTypes: n })),
  attachmentList: [],
  setAttachmentList: (n) => set((state) => ({ ...state, attachmentList: n })),
  cultures: [],
  setCultures: (n) => set((state) => ({ ...state, cultures: n })),
  regions: [],
  setRegions: (n) => set((state) => ({ ...state, regions: n })),
  regionId: null,
  region: null,
  setRegion: (n) => set((state) => ({
    ...state,
    region: n,
    regionId: n && n.value
      ? n.value
      : null
  })),
  widths: [],
  setWidths: (n) => set((state) => ({ ...state, widths: n })),
  lengths: [],
  setLengths: (n) => set((state) => ({ ...state, lengths: n })),
  heights: [],
  setHeights: (n) => set((state) => ({ ...state, heights: n })),
  dealers: [],
  setDealers: (n) => set((state) => ({ ...state, dealers: n })),
  dealer: null,
  dealerId: null,
  setDealer: (n) => set((state) => ({
    ...state,
    dealer: n,
    dealerId: n && n.value !== constants.OTHER_ID
      ? n.value
      : null
  })),
  agreementNumber: "",
  setAgreementNumber: (n) => set((state) => ({ ...state, agreementNumber: n })),
  companyEnableCreditCardPayments: false,
  setCompanyEnableCreditCardPayments: (n) => set((state) => ({ ...state, companyEnableCreditCardPayments: n })),
  typeOfPorch: null,
  setTypeOfPorch: (n) => set((state) => ({ ...state, typeOfPorch: n })),
  porchMin: 0,
  setPorchMin: (n) => set((state) => ({ ...state, porchMin: n })),
  porchMax: 0,
  setPorchMax: (n) => set((state) => ({ ...state, porchMax: n })),
  porchWall1Length: 0,
  setPorchWall1Length: (n) => set((state) => ({ ...state, porchWall1Length: n })),
  porchWall2Length: 0,
  setPorchWall2Length: (n) => set((state) => ({ ...state, porchWall2Length: n })),
  porchWall3Length: 0,
  setPorchWall3Length: (n) => set((state) => ({ ...state, porchWall3Length: n })),
  porchWall4Length: 0,
  setPorchWall4Length: (n) => set((state) => ({ ...state, porchWall4Length: n })),
  porchColorId: null,
  setPorchColorId: (n) => set((state) => ({ ...state, porchColorId: n })),
  porchColorName: "",
  setPorchColorName: (n) => set((state) => ({ ...state, porchColorName: n })),
  fontSize: 0,
  setFontSize: (n) => set((state) => ({ ...state, fontSize: n })),
  rulerOffSet: 0,
  setRulerOffSet: (n) => set((state) => ({ ...state, rulerOffSet: n })),
  addOnOptions: [],
  setAddOnOptions: (n) => set((state) => ({ ...state, addOnOptions: n })), // was unitAddOns
  defaultAddOns: [],
  setDefaultAddOns: (n) => set((state) => ({ ...state, defaultAddOns: n })), // was defaultAddonList
  addOns: [],
  setAddOns: (n) => set((state) => ({ ...state, addOns: n })), // was contractAddOns
  existingContractPairingContractId: null,
  setExistingContractPairingContractId: (n) => set((state) => ({ ...state, existingContractPairingContractId: n })),
  existingContractPairingAgreementNumber: null,
  setExistingContractPairingAgreementNumber: (n) => set((state) => ({ ...state, existingContractPairingAgreementNumber: n })),
  unpairContractId: null,
  setUnpairContractId: (n) => set((state) => ({ ...state, unpairContractId: n })),
  screenWarnings: {},
  setScreenWarnings: (newScreenWarnings) => set((state) => {
    return ({ ...state, screenWarnings: newScreenWarnings,  });
  }),
  manufacturers: [],
  setManufacturers: (n) => set((state) => ({ ...state, manufacturers: n })),
  employmentTypes: [],
  setEmploymentTypes: (n) => set((state) => ({ ...state, employmentTypes: n })),
  otherManufacturer: '',
  setOtherManufacturer: (n) => set((state) => ({ ...state, otherManufacturer: n })),
  productTypes: [],
  setProductTypes: (n) => set((state) => ({ ...state, productTypes: ui_helpers.getUniqueValues(n) })),
  subProducts: [],
  setSubProducts: (n) => set((state) => ({ ...state, subProducts: n })),
  subproductTypes: [],
  setSubproductTypes: (n) => set((state) => ({ ...state, subproductTypes: n })),
  subproduct: null,
  setSubproduct: (newSubproduct) => set((state) => {
    let newState = {
      ...state,
      subproduct: newSubproduct
    };
    // clear sku
    if (state.sku && state.subproduct && newSubproduct && Number(newSubproduct.value) !== state.subproduct.value) {
      newState = setSkuStateFields(newState, null);
    }
    return newState;
  }),
  otherSubproduct: "",
  setOtherSubproduct: (n) => set((state) => ({ ...state, otherSubproduct: n })),
  skus: [],
  setSkus: (n) => set((state) => ({ ...state, skus: n })), // was subProductSkuOptions
  unitPriceDisabled: false,
  setUnitPriceDisabled: (n) => set((state) => ({ ...state, unitPriceDisabled: n })),
  productType: null,
  setProductType: (n) => set((state) => ({ ...state, productType: n })),
  productTypeOtherText: "",
  setProductTypeOtherText: (n) => set((state) => ({ ...state, productTypeOtherText: n })),
  sku: null,
  hasSku: false,
  skuBasePrice: 0,
  setSku: (newSku) => set((state) => {
    const hasSku = newSku && newSku.value && newSku.value !== constants.OTHER_ID;
    let newState = { 
      ...state, 
      hasSku: hasSku
    };
    newState = getUnitPriceDisabled(newState, state.inventoryId, state.lastPairedInventoryId, state.enableBuildFeature,
      state.agreedPrice, state.contractType, hasSku);
    if (hasSku && state.isInitialLoad) {
      newState.unitPrice = state.unitPrice;
    } else if (hasSku && state.sku?.value !== newSku.value) { // only reset unitPrice when the user actually picks a different sku
      newState.unitPrice = newSku.defaultPrice; // does not take into account add-on prices
    }
    return setSkuStateFields(newState, newSku);
  }), // was selectedSku
  isPairing: false,
  setIsPairing: (n) => set((state) => ({ ...state, isPairing: n })),
  salespeople: [],
  setSalespeople: (newList) => set((state) => {
    let sp = state.salesperson;
    if (newList && newList.length 
      && (!sp || !_.includes(newList, state.salesperson))) {
      sp = newList[0];
    }
    return ({ 
      ...state, 
      salespeople: newList,
      salesperson: sp 
    });
  }),
  pendingPriceAdjustment: null,
  setPendingPriceAdjustment: (n) => set((state) => ({ ...state, pendingPriceAdjustment: n })),
  salesperson: "",
  setSalesperson: (n) => set((state) => ({ ...state, salesperson: n })),
  otherSalesperson: "",
  setOtherSalesperson: (n) => set((state) => ({ ...state, otherSalesperson: n })),
  unitTypes: [],
  setUnitTypes: (n) => set((state) => ({ ...state, unitTypes: n })),
  baseColors: [],
  setBaseColors: (n) => set((state) => ({ ...state, baseColors: n })),
  trimColors: [],
  setTrimColors: (n) => set((state) => ({ ...state, trimColors: n })),
  roofColors: [],
  setRoofColors: (n) => set((state) => ({ ...state, roofColors: n })),
  unitPrice: "0",
  setUnitPrice: (newUnitPrice) => set((state) => {
    const cleanNewUnitPrice = ui_helpers.cleanseCurrencyCharacters(newUnitPrice);
    let newState = { ...state };
    newState.unitPrice = cleanNewUnitPrice
      ? cleanNewUnitPrice
      : state.unitPrice
        ? state.unitPrice
        : 0;
    return updateFinancials(newState);
  }),
  taxRate: 0,
  setTaxRate: (newTaxRate) => set((state) => updateFinancials({ ...state, taxRate: newTaxRate })),
  taxRateString: "0.0",
  setTaxRateString: (newTaxRateString) => set((state) => {
    let newState = { ...state };
    newState.taxRate = parseFloat(newTaxRateString) ? parseFloat(newTaxRateString) : 0;
    if (newState.taxRate > 1.0) {
      newState.taxRate /= 100.0;
    }
    newState.taxRate = state.isTaxExempt
      ? 0.0
      : parseFloat(newState.taxRate.toFixed(5));
    newState = updateFinancials(newState);
    return {
      ...newState,
      taxRateString: newTaxRateString // do not reformat entered strings, jars the user
    };
  }),
  taxAmount: 0,
  setTaxAmount: (newTaxAmount) => 
    set((state) => {
      let newState = { ...state };
      const numericUnitPrice = parseFloat(newState.unitPrice);
      const unitPriceAdjustmentsSum =
        _.sumBy(
          _.filter(newState.priceAdjustments, (pa) => pa.includeInUnitPrice),
          (pa) => parseFloat(pa.amount)
        ) || 0.0;
      const taxAmountNumeric = parseFloat(ui_helpers.cleanseCurrencyCharacters(newTaxAmount));
      newState.taxRate = taxAmountNumeric / (numericUnitPrice + unitPriceAdjustmentsSum);
      newState = updateFinancials(newState);
      return {
        ...newState,
        taxAmount: newTaxAmount // do not reformat entered strings, jars the user
      };
    }),
  subtotal: 0,
  setSubtotal: (n) => set((state) => ({ ...state, subtotal: n })),
  widthFeet: "0",
  setWidthFeet: (n) => set((state) => ({ ...state, widthFeet: n })), // was unitWidthFeet
  widthFeetOtherText: "",
  setWidthFeetOtherText: (n) => set((state) => ({ ...state, widthFeetOtherText: n })), // was unitWidthFeetOtherText
  lengthFeet: "0",
  setLengthFeet: (n) => set((state) => ({ ...state, lengthFeet: n })), // was unitLengthFeet
  lengthFeetOtherText: "",
  setLengthFeetOtherText: (n) => set((state) => ({ ...state, lengthFeetOtherText: n })), // was unitlengthFeetOtherText
  heightFeet: "0",
  setHeightFeet: (n) => set((state) => ({ ...state, heightFeet: n })), // was unitHeightFeet
  heightFeetOtherText: "",
  setHeightFeetOtherText: (n) => set((state) => ({ ...state, heightFeetOtherText: n })), // was unitHeightFeetOtherText, otherHeight
  agreedPrice: null,
  setAgreedPrice: (n) => set((state) => getUnitPriceDisabled({...state}, state.inventoryId, state.lastPairedInventoryId, state.enableBuildFeature,
      n, state.contractType, state.hasSku)),
  inventoryId: null,
  setInventoryId: (n) => set((state) => getUnitPriceDisabled({...state}, n, state.lastPairedInventoryId, state.enableBuildFeature,
      state.agreedPrice, state.contractType, state.hasSku)),
  lastPairedInventoryId: null,
  setLastPairedInventoryId: (n) => set((state) => getUnitPriceDisabled({...state}, state.inventoryId, n, state.enableBuildFeature,
      state.agreedPrice, state.contractType, state.hasSku)),
  contactCount: 0,
  setContactCount: (n) => set((state) => ({ ...state, contactCount: n })),
  additionalContactData: {},
  setAdditionalContactData: (n) => set((state) => ({ ...state, additionalContactData: n })),
  typeOfPorch: null,
  setTypeOfPorch: (n) => set((state) => ({ ...state, typeOfPorch: n })),
  porchMax: null,
  setPorchMax: (n) => set((state) => ({ ...state, porchMax: n })),
  porchMin: null,
  setPorchMin: (n) => set((state) => ({ ...state, porchMin: n })),
  porchWall1Length: null,
  setPorchWall1Length: (n) => set((state) => ({ ...state, porchWall1Length: n })),
  porchWall2Length: null,
  setPorchWall2Length: (n) => set((state) => ({ ...state, porchWall2Length: n })),
  porchWall3Length: null,
  setPorchWall3Length: (n) => set((state) => ({ ...state, porchWall3Length: n })),
  porchWall4Length: null,
  setPorchWall4Length: (n) => set((state) => ({ ...state, porchWall4Length: n })),
  porchColorId: null,
  setPorchColorId: (n) => set((state) => ({ ...state, porchColorId: n })),
  rulerOffset: null,
  setRulerOffset: (n) => set((state) => ({ ...state, rulerOffset: n })),
  serialNumber: "0",
  setSerialNumber: (n) => set((state) => ({ ...state, serialNumber: ui_helpers.capitalizeAllLetters(n) })),
  manufacturer: null,
  manufacturerId: null, // was mfgId
  loadedExistingManufacturerId: null,
  setManufacturer: (n) => set((state) => ({
    ...state,
    manufacturer: n,
    manufacturerId: n && n.value // !== constants.OTHER_ID
      ? n.value
      : null
  })),
  isNewBuild: false,
  estimatedDeliveryDate: null,
  setEstimatedDeliveryDate: (n) => set((state) => ({ ...state, estimatedDeliveryDate: ui_helpers.formatDateField(n) })),
  otherRoofColor: "",
  setOtherRoofColor: (n) => set((state) => ({ ...state, otherRoofColor: n })),
  otherTrimColor: "",
  setOtherTrimColor: (n) => set((state) => ({ ...state, otherTrimColor: n })),
  otherBaseColor: "",
  setOtherBaseColor: (n) => set((state) => ({ ...state, otherBaseColor: n })),
  customSerialEnabled: false,
  setCustomSerialEnabled: (n) => set((state) => ({ ...state, customSerialEnabled: n })),
  enableCustomSerialGeneration: false,
  setEnableCustomSerialGeneration: (n) => set((state) => setCustomSerialState({...state}, n, state.unitIsNew, state.unitIsInventory)),
  unitIsNew: null,
  setUnitIsNew: (n) => set((state) => setCustomSerialState({...state}, state.enableCustomSerialGeneration, n, state.unitIsInventory)),
  unitIsInventory: null,
  setUnitIsInventory: (n) => set((state) => setCustomSerialState({...state}, state.enableCustomSerialGeneration, state.unitIsNew, n)),
  roofColor: null,
  setRoofColor: (n) => set((state) => ({ ...state, roofColor: n })),
  trimColor: null,
  setTrimColor: (n) => set((state) => ({ ...state, trimColor: n })),
  baseColor: null,
  setBaseColor: (n) => set((state) => ({ ...state, baseColor: n })),
  unitOtherColorText: null,
  setUnitOtherColorText: (n) => set((state) => ({ ...state, unitOtherColorText: n })),
  hideUnitType: false,
  setHideUnitType: (n) => set((state) => ({ ...state, hideUnitType: n })),
  ownershipCompanyList: [],
  setOwnershipCompanyList: (n) => set((state) => ({ ...state, setOwnershipCompanyList: n })),
  unitType: null,
  setUnitType: (n) => set((state) => ({ ...state, unitType: n })),
  unitTypeOtherText: "", // was otherUnitType
  setUnitTypeOtherText: (n) => set((state) => ({ ...state, unitTypeOtherText: n })),
  quoteDownPayment: "",
  setQuoteDownPayment: (n) => set((state) => ({ ...state, quoteDownPayment: ui_helpers.cleanseCurrencyCharacters(n) })),
  priceAdjustments: [],
  setPriceAdjustments: (newPriceAdjustments) => set((state) => updateFinancials({ ...state, priceAdjustments: newPriceAdjustments })),
  pristineUnitIsNew: [],
  setPristineUnitIsNew: (n) => set((state) => ({ ...state, pristineUnitIsNew: n })),
  paymentList: [],
  setPaymentList: (n) => set((state) => updateFinancials({ ...state, paymentList: n })),
  cards: [],
  setCards: (n) => set((state) => ({ ...state, cards: n })),
  bankAccounts: [],
  setBankAccounts: (n) => set((state) => ({ ...state, bankAccounts: n })),
  associatedBundles: [],
  setAssociatedBundles: (n) => set((state) => ({ ...state, associatedBundles: n })),
  bundlesToDelete: [],
  setBundlesToDelete: (n) => set((state) => ({ ...state, bundlesToDelete: n })),
  bundlePrice: 0,
  setBundlePrice: (n) => set((state) => ({ ...state, bundlePrice: n })),
  deleteBundle: (bundleId) => set((state) => ({ ...state, addOns: _.reject(state.addOns, x => x.bundleId === bundleId) })),
  creditCardSurcharge: 0,
  setCreditCardSurcharge: (n) => set((state) => ({ ...state, creditCardSurcharge: n })),
  damageLiabilityWaiverAmount: "", // was ldwAmount
  setDamageLiabilityWaiverAmount: (n) => set((state) => ({ ...state, damageLiabilityWaiverAmount: n })),
  optedOutOfDamageLiabilityWaiver: false,
  setOptedOutOfDamageLiabilityWaiver: (n) => set((state) => ({ ...state, optedOutOfDamageLiabilityWaiver: n })),
  enableRecurringPayments: false, // was enableRecurring
  setEnableRecurringPayments: (n) => set((state) => ({ ...state, enableRecurringPayments: n })),
  mfgExpirationDate: null,
  setMfgExpirationDate: (n) => set((state) => ({ ...state, mfgExpirationDate: n })),
  searchText: "",
  setSearchText: (n) => set((state) => ({ ...state, searchText: n })),
  unpairedInvList: null,
  setUnpairedInvList: (n) => set((state) => ({ ...state, unpairedInvList: n })),
  buildingOrientations: [],
  setBuildingOrientations: (n) => set((state) => ({ ...state, buildingOrientations: n })),
  buildingOrientation: null,
  setBuildingOrientation: (n) => set((state) => ({ ...state, buildingOrientation: n })),
  deliveryInstructions: "",
  setDeliveryInstructions: (n) => set((state) => ({ ...state, deliveryInstructions: n })),
  disableSale: false,
  setDisableSale: (n) => set((state) => ({ ...state, disableSale: n })),
  defaultUnitTypeId: null,
  setDefaultUnitTypeId: (n) => set((state) => ({ ...state, defaultUnitTypeId: n })),
  dueDays: false,
  setDueDays: (n) => set((state) => ({ ...state, dueDays: n })),
  validationMessage: null,
  setValidationMessage: (n) => set((state) => ({ ...state, validationMessage: n })),
  phaseName: "",
  setPhaseName: (n) => set((state) => ({ ...state, phaseName: n })),
  includedInitialPayment: false,
  setIncludedInitialPayment: (n) => set((state) => ({ ...state, includedInitialPayment: n })),
  initialPaymentAmount: 0,
  setInitialPaymentAmount: (n) => set((state) => updateFinancials({ ...state, initialPaymentAmount: ui_helpers.cleanseCurrencyCharacters(n) })),
  sideFeePayment: 0.0,
  setSideFeePayment: (n) => set((state) => ({ ...state, sideFeePayment: n })),
  maxInitialPaymentAmount: 0,
  setMaxInitialPaymentAmount: (n) => set((state) => ({ ...state, maxInitialPaymentAmount: n })),
  isTaxExempt: false,
  setIsTaxExempt: (n) => set((state) => updateFinancials({ ...state, isTaxExempt: n })),
  taxExemptionForm: null,
  setTaxExemptionForm: (n) => set((state) => ({ ...state, taxExemptionForm: n })),
  convertTo: "",
  setConvertTo: (n) => set((state) => ({ ...state, convertTo: n })),
  selectedTermInfo: null,
  setSelectedTermInfo: (n) => set((state) => ({ ...state, selectedTermInfo: n })),
  promotionCode: "",
  setPromotionCode: (n) => set((state) => ({ ...state, promotionCode: n })),
  promotionCodeTemp: "",
  setPromotionCodeTemp: (n) => set((state) => {
    const cleanPromoCode = _.trim(n).toUpperCase();
    return ({
      ...state, 
      promotionCodeTemp: cleanPromoCode, 
      // promotionCode: cleanPromoCode
    });
  }),
  paymentDueDayOfMonth: null,
  setPaymentDueDayOfMonth: (n) => set((state) => ({ ...state, paymentDueDayOfMonth: n })),
  pricingData: null,
  setPricingData: (n) => set((state) => ({ ...state, pricingData: n })),
  typeOfContractStatus: null,
  setTypeOfContractStatus: (n) => set((state) => ({ ...state, typeOfContractStatus: n })),
  savedAddons: [],
  setSavedAddons: (n) => set((state) => ({ ...state, savedAddons: n })),
  paymentTransferIntentId: null,
  setPaymentTransferIntentId: (n) => set((state) => ({ ...state, paymentTransferIntentId: n })),
  contractTransferPayments: [],
  setContractTransferPayments: (n) => set((state) => ({ ...state, contractTransferPayments: n })),
  pendingTransfer: false,
  setPendingTransfer: (n) => set((state) => ({ ...state, pendingTransfer: n })),
  fieldWarnings: [],
  setFieldWarnings: (newFieldWarnings) => set((state) => {
    let newScreenWarnings = {};
    _.each(newFieldWarnings, w => Object.assign(newScreenWarnings, {[w.field]: w.text}));
    return ({ ...state, fieldWarnings: newFieldWarnings, screenWarnings: newScreenWarnings });
  }),
  canSetRetained: false,
  setCanSetRetained: (n) => set((state) => ({ ...state, canSetRetained: n })),
  companyAcceptsPayment: null,
  setCompanyAcceptsPayment: (n) => set((state) => ({ ...state, companyAcceptsPayment: n })),
  rtoTaxExemptionEnabled: false,
  setRtoTaxExemptionEnabled: (n) => set((state) => ({ ...state, rtoTaxExemptionEnabled: n })),
  warnings: [],
  autoShowEditor: false,
  manualCard: null,
  setManualCard: (n) => set((state) => ({ ...state, manualCard: n })),
  setAutoShowEditor: (n) => set((state) => ({ ...state, autoShowEditor: n })),
  setWarnings: (n) => set((state) => ({ ...state, warnings: n })),
  getWarnings: (overridePhaseName = null) => getWarnings(get(), overridePhaseName),
  assessValidity: (overridePhaseName = null) => set((state) => {
    const newState = getWarnings(state, overridePhaseName);
    let newScreenWarnings = {};
    _.each(newState.warnings, w => Object.assign(newScreenWarnings, {[w.field]: w.text}));
    return ({...newState, screenWarnings: newScreenWarnings});
  }),
  reset: () => set(initialState),
  resolveLengthFeet: () => resolveLength(get()),
  resolveWidthFeet: () => resolveWidth(get())
}));

export default useContractStore;
